import React from 'react';
import PropTypes from 'prop-types';

function ExplicitTag({ size = 12, className, style }) {
  return (
    <svg width={size} height={size} className={className} style={style} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="12" height="12" rx="2" fill="#5A5A5A"/>
      <path d="M3.82262 2.5H8.39262V3.52H4.97262V5.46H7.79262V6.45H4.97262V8.48H8.51262V9.5H3.82262V2.5Z" fill="white"/>
    </svg>
  )
}

ExplicitTag.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
}

export default ExplicitTag;
